import React, { useState } from "react";

import Link from "components/link";
import { ClubToggle } from "components/club-toggle";
import { ChipsWithImage } from "modules/DesignSystem/components/Chips";
import { CategoryListScreenSection } from "resources/AudiotekaApi";

import css from "./category-list.module.scss";

interface CategoriesProps {
  section: CategoryListScreenSection;
  title: string;
}

function CategoryList({ section, title }: CategoriesProps) {
  const [isClub, setClub] = useState(false);

  const categories = section._embedded["app:category"];
  const clubCategories = section._embedded["app:club-category"];
  const categoryList = clubCategories && isClub ? clubCategories : categories;

  return (
    <div className={css.categoryList}>
      {title ? <h2 className={css.title}>{title}</h2> : null}
      {clubCategories ? <ClubToggle isClub={isClub} onClubToggle={setClub} /> : null}
      <ul className={css.list}>
        {categoryList.map((category) => {
          const params = { id: category.slug || category.id } as any;

          if (isClub) {
            params.club = true;
          }

          return (
            <li className={css.item} key={category.id}>
              <ChipsWithImage
                as={Link}
                title={category.name}
                club={isClub}
                image={`${category.image_url}?h=120&auto=format`}
                label={category.name}
                params={params}
                route="category"
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default CategoryList;
